import React, { useState, useCallback } from 'react';

interface Props {
  children: React.ReactElement;
}

interface ApiErrorContext {
  messages: { message: string, status: number }[];
  addMessages: (message: string, status: number) => void;
  clearMessages: () => void;
}

export const APIErrorContext = React.createContext<ApiErrorContext>({
  messages: [],
  addMessages: () => {},
  clearMessages: () => {}
});

export default function APIErrorProvider({ children }: Props) {
  const [messages, setMessages] = useState<{ message: string, status: number }[]>([]);

  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);


  const addMessages = useCallback((message: string, status: number) => {
    setMessages(prevErrors => [...prevErrors, { message, status }]);
  }, []);

  const contextValue = {
    messages,
    addMessages,
    clearMessages,
  };

  return (
    <APIErrorContext.Provider value={contextValue}>
      {children}
    </APIErrorContext.Provider>
  );
}